import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Common/ScrollUp.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/components/Testimonials/RotatingTestimonial.tsx");
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/image-component.js")